import { RuleResult } from 'types/DeclarationP5'
import { excludeDeleted } from 'shared/lib/common-util'
import { TransportEquipment } from '../../common/types'

const C0055Validator = {
  isContainerIdentificationNumberRequired: ({
    containerIndicator,
    transportEquipments,
    transportEquipment,
  }: {
    containerIndicator?: string
    transportEquipments?: TransportEquipment[]
    transportEquipment?: TransportEquipment
  }): RuleResult => {
    if (containerIndicator !== 'true') return 'NOT_ALLOWED'

    const equipments = transportEquipments?.filter(excludeDeleted) ?? []
    const hasAtLeastOneContainerNumber = equipments.some((
      containerItem,
    ) => containerItem.containerIdentificationNumber
          && containerItem.containerIdentificationNumber.trim().length > 0
      && containerItem.sequenceNumber !== transportEquipment?.sequenceNumber)

    if (hasAtLeastOneContainerNumber) return 'OPTIONAL'

    return 'REQUIRED'
  },
} as const

export default C0055Validator
